import type { AccordionSingleProps } from '@radix-ui/react-accordion';

export enum AccordionTypes {
  Default = 'default',
  Error = ' error',
}

export type AccordionProps = {
  accordionType?: AccordionTypes;
} & Omit<AccordionSingleProps, 'type'>;

export type ErrorAccordionProps<T extends ErrorMessage> = {
  errors?: T[];
  warnings?: T[];
  arrowHeight?: number;
  arrowWidth?: number;
} & AccordionProps;

export type ErrorMessage = {
  errorMessage?: string;
  subMessage?: string;
};

export enum ErrorTypes {
  Error = 'Error',
  Warning = 'Warning',
}

export type ErrorWarningTextProps = {
  type: ErrorTypes;
  message?: string;
  subMessage?: string;
};
